<template>
	<div class="row q-col-gutter-sm">
		<div class="col-12 col-sm-6 col-md-3 col-lg">
			<q-select v-model="color"
					  :label="$t('label.color')"
					  :options="colorsWithEmptyValue"
					  option-value="uid"
					  option-label="value"
					  :loading="loadingSpeciesFilters"
					  map-options
					  emit-value
			/>
		</div>

		<div class="col-12 col-sm-6 col-md-3 col-lg">
			<q-select v-model="application"
					  :label="$t('label.application')"
					  :options="applicationsWithEmptyValue"
					  option-value="uid"
					  option-label="value"
					  :loading="loadingSpeciesFilters"
					  map-options
					  emit-value
			/>
		</div>

		<div class="col-12 col-sm-6 col-md-3 col-lg">
			<q-field :label="$t('label.availability')" stack-label borderless>
				<template v-slot:control>
					<q-checkbox v-for="value in [1,2,3,4]"
								:key="value"
								v-model="availability"
								:val="value"
					></q-checkbox>
				</template>
			</q-field>
		</div>

		<div class="col-12 col-sm-6 col-md-3 col-lg">
			<q-field :label="$t('label.pricegroup')" stack-label borderless>
				<template v-slot:control>
					<q-checkbox v-for="value in [1,2,3,4]"
								:key="value"
								v-model="pricegroup"
								:val="value"
					></q-checkbox>
				</template>
			</q-field>
		</div>

		<div class="col-6 col-sm-6 col-md-3 col-lg">
			<q-field :label="$t('label.fsc')" stack-label borderless>
				<q-checkbox type="checkbox" v-model="fsc"/>
			</q-field>
		</div>

		<div class="col-6 col-sm-6 col-md-3 col-lg">
			<q-field :label="$t('label.pefc')" stack-label borderless>
				<q-checkbox type="checkbox" v-model="pefc"/>
			</q-field>
		</div>

		<div class="col-12 col-sm-6 col-md-3 col-lg">
			<q-select v-model="occurrence"
					  :label="$t('label.occurrence')"
					  :options="occurencesWithEmptyValue"
					  option-value="uid"
					  option-label="value"
					  :loading="loadingSpeciesFilters"
					  map-options
					  emit-value
			/>
		</div>
	</div>
</template>

<script>
	import {SET_FILTER_APPLICATION, SET_FILTER_AVAILABILITY, SET_FILTER_COLOR, SET_FILTER_FSC, SET_FILTER_OCCURRENCE, SET_FILTER_PEFC, SET_FILTER_PRICEGROUP} from "@/store/mutations.type";
	import {mapGetters} from "vuex";

	export default {
		name: "GalleryFilters",
		computed: {
			...mapGetters(['loadingSpeciesFilters', 'speciesColorList', 'speciesApplicationList', 'speciesOccurenceList']),
			colorsWithEmptyValue() {
				return [{uid: 0, value: this.$t('input.allColors')}, ...this.speciesColorList];
			},
			applicationsWithEmptyValue() {
				return [{uid: 0, value: this.$t('input.allApplications')}, ...this.speciesApplicationList];
			},
			occurencesWithEmptyValue() {
				return [{uid: 0, value: this.$t('input.allOccurrences')}, ...this.speciesOccurenceList];
			},
			color: {
				get() {
					return this.$store.state.species.searchParams.color;
				},
				set(value) {
					this.$store.commit(SET_FILTER_COLOR, value);
				}
			},
			application: {
				get() {
					return this.$store.state.species.searchParams.application;
				},
				set(value) {
					this.$store.commit(SET_FILTER_APPLICATION, value);
				}
			},
			availability: {
				get() {
					return this.$store.state.species.searchParams.availability;
				},
				set(value) {
					this.$store.commit(SET_FILTER_AVAILABILITY, value);
				}
			},
			pricegroup: {
				get() {
					return this.$store.state.species.searchParams.pricegroup;
				},
				set(value) {
					this.$store.commit(SET_FILTER_PRICEGROUP, value);
				}
			},
			occurrence: {
				get() {
					return this.$store.state.species.searchParams.occurrence;
				},
				set(value) {
					this.$store.commit(SET_FILTER_OCCURRENCE, value);
				}
			},
			fsc: {
				get() {
					return this.$store.state.species.searchParams.fsc;
				},
				set(value) {
					this.$store.commit(SET_FILTER_FSC, value);
				}
			},
			pefc: {
				get() {
					return this.$store.state.species.searchParams.pefc;
				},
				set(value) {
					this.$store.commit(SET_FILTER_PEFC, value);
				}
			}
		}
	}
</script>